import { VHeaders } from '@/models/pagedlistmodel';
import * as marked from 'marked';

export function getHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t('depositLogNote.gridHeaders.note') as string,
      align: 'left',
      sortable: false,
      value: 'noteText',
      fieldType: 'html',
      filters: [
        (item) => {
          const htmlData = marked(item);
          return htmlData.length > 100
            ? htmlData.substring(0, 100) + '..'
            : htmlData;
        },
      ],
      class: 'w-100 text-truncate',
    },
    {
      text: vm.$parent.$t('depositLogNote.gridHeaders.addedAt') as string,
      value: 'createdAt',
      sortable: true,
      align: 'left',
      fieldType: 'date',
    },
    {
      text: vm.$parent.$t('depositLogNote.gridHeaders.addedBy') as string,
      value: 'createdByEmail',
      align: 'left',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: vm.$parent.$t('depositLogNote.gridHeaders.actions') as string,
      sortable: false,
    },
  ];
}
